export type ConfirmMode = 'ask' | 'delete'

/** A delete is the one ask where Enter must not go ahead: Cancel takes the focus and the action reads as dangerous. */
export function confirmShape(mode: ConfirmMode): { focus: 'cancel' | 'ok'; okVariant: 'primary' | 'danger' } {
  return mode === 'delete' ? { focus: 'cancel', okVariant: 'danger' } : { focus: 'ok', okVariant: 'primary' }
}
